import { Table } from 'react-bootstrap';
import styled from 'styled-components';

export const TableWrapper = styled(Table)`
    margin-bottom: 0px;

    & > thead > tr > th {
        text-align: center;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
        line-height: 1;
        padding-bottom: 2px;
    }

    & > tbody > tr > td {
        vertical-align: middle;
        text-align: center;
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
        padding: ${p => p.tightspacing ? '2px' : '5px'};
    }

    .label {
        font-size: 90%;
    }
`;

export const FormWrapper = styled.div`
    .control-label {
        text-align: left;
        font-weight: normal;
    }
`;